<!-- <app-file-upload></app-file-upload> -->
<router-outlet></router-outlet>
<ngx-spinner></ngx-spinner>
<ngx-spinner name="file">Processing your file!</ngx-spinner>
